import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
const MRLForm = (props) => {
  const frmRef = useRef({});

  const [close, setClose] = useState(false);
  const [cropdata, setCropData] = useState([]);
  const [cropId, setCropId] = useState([]);
  const [unitId, setUnitId] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [MRLData, setMRLData] = useState([]);

  const [active_ingredient_id, setActive_ingredient_id] = useState();
  const [activeIngredientList, setActiveIngredientList] = useState();
  const [codexId, setcodexId] = useState();
  const [reminder, setReminder] = useState();

  const { sendRequest: getcrop } = useHttp();
  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropData(res);
        }
      }
    );
  }, [getcrop]);

  const { sendRequest: postActiveIngredient } = useHttp();

  const ActiveIngredientsubmitHandler = (e) => {
    e.preventDefault();

    const data = {
      active_ingredient_name: frmRef.current.activeIngredientName.value.trim(),
      phi_in_day: frmRef.current.phi_in_day.value.trim(),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
    };

    //console.log(data);
    postActiveIngredient(
      {
        url: "/api/activeIngredient/",
        // method: props.update ? "PUT" : "POST",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Active ingredient added`);

        frmRef.current.activeIngredientName.value = "";
        frmRef.current.phi_in_day.value = "";

        setClose(false);
      }
    );
  };

  const { sendRequest: postMRL } = useHttp();

  const mrlsubmitHandler = (e) => {
    e.preventDefault();

    var list = MRLData.filter(
      (item) =>
        parseInt(item.cropId) == parseInt(frmRef.current.cropId.value) &&
        item.codexId == frmRef.current.codexId.value &&
        parseInt(item.active_ingredient_id) ==
          parseInt(frmRef.current.active_ingredient_id.value)
    );
    //console.log("already mrl", list);
    if (list.length == 0) {
      //console.log("already insert", list);
      const data = {
        active_ingredient_id: frmRef.current.active_ingredient_id.value.trim(),
        codexId: frmRef.current.codexId.value.trim(),
        cropId: frmRef.current.cropId.value.trim(),
        mrl_value_mg_per_kg: frmRef.current.mrl_limit.value.trim(),
        Reference: frmRef.current.reference_url.value.trim(),
        reminderNotification: frmRef.current.reminderNotification.value.trim(),
        status: 1,
        orgId: parseInt(localStorage.getItem("orgId")),
        createdBy: parseInt(localStorage.getItem("id")),
        createdDate: new Date(),
        serviceId: props.sId, 
      };

      postMRL(
        {
          url: "/api/mrlCrops/",
          // method: props.update ? "PUT" : "POST",
          method: "POST",
          body: data,
        },
        (data) => {
          toast.success(`MRL detail added`);
          setClose(false);
          props.addForm(false);
        }
      );
    } else {
      toast.success(`MRL Active ingredient already present`);
    }
  };

  const { sendRequest: getActiveIngredientName } = useHttp();

  const getActiveIngredientNameDetail = () => {
    getActiveIngredientName(
      {
        url: "/api/activeIngredient/",
      },
      (res) => {
        if (res) {
          //console.log("activeIngredient", res);
          setActiveIngredientList(res);
        }
      }
    );
  };

  useEffect(() => {
    getActiveIngredientNameDetail();
  }, [getActiveIngredientName]);

  const { sendRequest: getMRLData } = useHttp();

  const getMRLDetail = () => {
    getMRLData(
      {
        url: "/api/mrlCrops/",
      },
      (res) => {
        if (res) {
          //console.log("mrlCrops", res);
          setMRLData(res);
        }
      }
    );
  };

  useEffect(() => {
    getMRLDetail();
  }, [getMRLData]);

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          //console.log("units", res);

          var unitFilter = res.filter((item) => item.unitTypeId == 6);

          setUnitList(unitFilter);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  return (
    <>
      <div className="modal fade" id="modal-sm-active-ingredient">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <label className="modal-title">Active Ingredient Details</label>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              style={{ margin: "10px" }}
              onSubmit={ActiveIngredientsubmitHandler}
            >
              <div className="modal-body">
                <div className="form-group">
                  <label>Active Ingredient Name</label>

                  <input
                    type={"text"}
                    id={"activeIngredientName"}
                    required
                    ref={(el) => (frmRef.current["activeIngredientName"] = el)}
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Pre-harvest Interval(Day)</label>

                  <input
                    type={"text"}
                    id={"phi_in_day"}
                    required
                    ref={(el) => (frmRef.current["phi_in_day"] = el)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={mrlsubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">MRL Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Crop Name</label>

                        <select
                          id="cropNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropId"] = el)}
                          value={cropId}
                          onChange={(e) => {
                            setCropId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Crop</option>
                          {cropdata &&
                            cropdata.map((x) => (
                              <option key={x.cropId} value={x.cropId}>
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Followed MRL Norm </label>
                        <select
                          required
                          id="cropNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["codexId"] = el)}
                          value={codexId}
                          onChange={(e) => {
                            setcodexId(e.target.value);
                          }}
                        >
                          <option value="">Select Followed MRL Norm</option>
                          <option value="U.S. MRL">U.S. MRL</option>
                          <option value="Codex MRL">Codex MRL</option>
                          <option value="E.U. MRL">E.U. MRL</option>
                          <option value="Canadian MRL">Canadian MRL</option>
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Active ingredient </label>
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-sm-active-ingredient"
                        >
                          +
                        </button>
                        &nbsp;&nbsp;
                        <select
                          id="cropNameId"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["active_ingredient_id"] = el)
                          }
                          value={active_ingredient_id}
                          onChange={(e) => {
                            setActive_ingredient_id(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Active ingredient</option>
                          {activeIngredientList &&
                            activeIngredientList.map((x) => (
                              <option
                                key={x.activeIngredientsId}
                                value={x.activeIngredientsId}
                              >
                                {x.active_ingredient_name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>MRL limit*</label>
                        <input
                          type="number"
                          step="0.01"
                          id="mrl_limit"
                          className="form-control"
                          ref={(el) => (frmRef.current["mrl_limit"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Unit </label>
                        <select
                          id="unitId"
                          className="form-control"
                          ref={(el) => (frmRef.current["unitId"] = el)}
                          value={unitId}
                          onChange={(e) => {
                            setUnitId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Unit</option>
                          {unitList &&
                            unitList.map((x) => (
                              <option key={x.Unit_id} value={x.Unit_id}>
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>{" "}
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Enter Reference URL(optional) </label>
                        <input
                          type="text"
                          id="reference_url"
                          className="form-control"
                          ref={(el) => (frmRef.current["reference_url"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Reminder Notification</label>
                        <select
                          id="cropNameId"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["reminderNotification"] = el)
                          }
                          value={reminder}
                          onChange={(e) => {
                            setReminder(e.target.value);
                          }}
                          required
                        >
                          <option value="">Reminder Notification</option>
                          <option value="Weekly">Weekly</option>
                          <option value="Monthly">Monthly</option>
                          <option value="3 months">3 months</option>
                          <option value="6 months">6 months</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default MRLForm;
